export function formatBadgeCount(count: number): string | null {
  if (count === 0) return null
  if (count > 99) return '99+'
  return count.toString()
}
